import { useTranslation } from "react-i18next";
import { WifiOff } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export const OfflineBanner = () => {
  const { online } = useSettings();
  const { t } = useTranslation();
  if (online) return null;
  return (
    <div data-testid="offline-banner"
      className="fixed top-16 inset-x-0 z-[60] bg-amber-500 text-black text-sm font-semibold flex items-center justify-center gap-2 py-2 px-4 text-center">
      <WifiOff size={16} /> {t("offline.badge")} · {t("offline.message")}
    </div>
  );
};
